import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-34503a27"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "node"
};
var _hoisted_2 = {
  class: "item"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line-left"
  }, null, -1);
});

var _hoisted_4 = {
  class: "switch"
};
var _hoisted_5 = {
  key: 0,
  class: "none"
};
var _hoisted_6 = {
  class: "name"
};
var _hoisted_7 = {
  class: "btn-name"
};
import { watch, ref } from 'vue';
import PedigreeTree from '../pedigreeTree';
export default {
  props: {
    list: {
      // 接收父组件传值,并设置默认值
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['update:modelValue', 'triggerMenu', 'initData'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;

    var triggerMenu = function triggerMenu(item) {
      emits('triggerMenu', item);
    };

    var initData = function initData() {
      emits('initData');
    };

    var list = ref([]);
    watch(function () {
      list.value = props.list;
    }, {
      deep: true,
      immediate: true
    });

    var changeStatus = function changeStatus(index) {
      if (list.value[index].status === true) {
        list.value[index].status = false;
      } else {
        list.value[index].status = list.value[index].hasbranch;
      }

      if (list.value[index].groupHead === 'group') {
        list.value[index].groupHead = 'group_s';
      } else if (list.value[index].groupHead === 'group_s') {
        list.value[index].groupHead = 'group';
      }
    };

    return function (_ctx, _cache) {
      var _component_remove = _resolveComponent("remove");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_circle_plus = _resolveComponent("circle-plus");

      var _component_back = _resolveComponent("back");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([{
          expand: _ctx.hasbranch
        }, {
          'last-item': _ctx.lastitem
        }])
      }, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [!item.hasbranch ? (_openBlock(), _createElementBlock("div", _hoisted_5)) : item.status ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          onClick: function onClick($event) {
            return changeStatus(index);
          },
          class: "plusIcon"
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_remove)];
          }),
          _: 2
        }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 2,
          onClick: function onClick($event) {
            return changeStatus(index);
          },
          class: "plusIcon"
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_circle_plus)];
          }),
          _: 2
        }, 1032, ["onClick"]))]), _createVNode(_component_el_icon, {
          class: "insertIcon",
          onClick: function onClick($event) {
            return triggerMenu(item);
          }
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_back)];
          }),
          _: 2
        }, 1032, ["onClick"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
          class: _normalizeClass(["text", {
            daughter: item.sex == 1
          }])
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(item.name), 1)])], 2)]), _createElementVNode("span", null, "[" + _toDisplayString(item.levelName) + "]", 1)]), item.status && item.child != null && item.child && item.child.length > 0 ? (_openBlock(), _createBlock(_unref(PedigreeTree), {
          key: 0,
          class: "child",
          list: item.child,
          onTriggerMenu: triggerMenu,
          onInitData: initData
        }, null, 8, ["list"])) : _createCommentVNode("", true)]);
      }), 128))])], 2);
    };
  }
};